import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody } from "shards-react";

import VChart from "./VChart";

const chartOptions = {
  responsive: true,
  legend: {
    position: "top",
  },
  scales: {
    xAxes: [
      {
        gridLines: false,
        ticks: {
          autoSkip: true,
          maxRotation: 45,
          maxTicksLimit: 12,
          minRotation: 0,
        },
      }
    ],
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          max: 100,
          callback(value) {
            return `${value}%`;
          },
        },
      }
    ],
  },
  tooltips: {
    mode: "index",
    intersect: false,
  },
};

const RetentionOverview = (props) => {
  const { labels, datasets } = useMemo(() => {
    const series = Array.isArray(props.series) ? props.series : [];
    return {
      labels: series.map(item => item.period),
      datasets: [
        {
          label: 'Retention Rate',
          data: series.map(item => Number(item.retentionRate || 0)),
          color: '#007bff',
        },
        {
          label: 'Churn Rate',
          data: series.map(item => Number(item.churnRate || 0)),
          color: '#ff4169',
        },
      ],
    };
  }, [props.series]);
  const hasData = props.series.some(item => (
    Number(item.start || 0) > 0
    || Number(item.end || 0) > 0
    || Number(item.new || 0) > 0
    || Number(item.returned || 0) > 0
  ));

  return (
    <Card small className="h-100">
      <CardHeader className="border-bottom">
        <h6 className="m-0">{props.title}</h6>
      </CardHeader>
      <CardBody className="pt-0">
        {hasData ? (
          <VChart
            labels={labels}
            datasets={datasets}
            type="line"
            chartOptions={chartOptions}
          />
        ) : (
          <div className="d-flex align-items-center justify-content-center text-muted py-5">
            No paid subscription retention data in the selected range.
          </div>
        )}
      </CardBody>
    </Card>
  );
};

RetentionOverview.propTypes = {
  title: PropTypes.string,
  series: PropTypes.array,
};

RetentionOverview.defaultProps = {
  title: "Paid Subscription Retention",
  series: [],
};

export default RetentionOverview;
